module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v(_vm._s(_vm.date) + "："), _c('a', {
    attrs: {
      "href": _vm.post.link
    }
  }, [_vm._v(_vm._s(_vm.post.title.rendered))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59b42b94!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/NewsList.vue
// module id = 384
// module chunks = 2